import { APPROVAL_LIKELIHOOD_SCORES } from './CurrentDocument';


export default APPROVAL_LIKELIHOOD_SCORES;
